<template>
  <div v-if="isReady">

    <!-- STATIC OVERVIEW PICTURE -->
    <section 
    v-if="!article.content.hasOwnProperty('pageSlider') || !article.content.pageSlider.length"
    :class="{ 
    'hero': true,
    'skew-bottom': true }"
    style="overflow:hidden !important;margin-top:4.5rem;">
    <img :src="assetsBaseUrl + article.content.seo.image.path" style="width:100%;height:auto;">

    </section>

    <!-- PAGESLIDER -->
      <swiper v-else :options="swiperOption" class="hero is-medium slider skew" tag="section">
        <swiper-slide v-for="(i, index) in pageSliderItems" :key="'x' + index" :style="'background-image: url(' + assetsBaseUrl + i.content.seo.image.path + ');'" @click.native="$router.push('/' + (i.type === 1 ? 'projekte/' : (i.type === 2 ? 'themen/' : '')) + i.content.seo.niceUrl)">

      <div class="hero-head">
      </div>
      <div class="hero-body">
      </div>
      <div class="hero-foot">
        <div class="container" style="padding-bottom: 3rem;">
          <div class="columns">
            <div class="column is-10 is-offset-1 cursor">
              <div class="slider-headline is-size-5 is-size-6-mobile skew-back">
                {{ i.content.seo.title }}
              </div>
              <div class="slider-text is-size-6 is-size-7-mobile skew-back" v-if="i.content.seo.description.length">
                {{ i.content.seo.description }}
              </div>
            </div>
          </div>
        </div>
      </div>

        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    </swiper>

    <!-- PROJECT VIEW -->
    <app-project 
    v-if="article.type==1"
    :view="article"
    :lightbox="lightbox" 
    :lightboxImg="lightboxImg"
    @showLightbox="showLightbox($event)"></app-project>

    <!-- TOPIC VIEW -->
    <app-topic 
    v-if="article.type==2"
    :view="article" 
    :lightbox="lightbox" 
    :lightboxImg="lightboxImg"
    @showLightbox="showLightbox($event)"></app-topic>

    <!-- SECTIONS VIEW -->
    <app-sections 
    v-if="article.type==3"
    :view="article"></app-sections>

    <!-- CONTENT VIEW -->
    <app-content 
    v-if="article.type==4"
    :view="article"></app-content>

    <!-- TEAM VIEW -->
    <app-team 
    v-if="article.type==5"
    :view="article"></app-team>

    <!-- SHARING not on Homepage -->
    <section v-if="article.id!=48" class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-12">
            <vue-goodshare-facebook has_icon :page_url="thisPage"></vue-goodshare-facebook>
            <vue-goodshare-twitter has_icon :page_url="thisPage"></vue-goodshare-twitter>
            <vue-goodshare-linkedin has_icon :page_url="thisPage"></vue-goodshare-linkedin>
            <vue-goodshare-tumblr has_icon :page_url="thisPage"></vue-goodshare-tumblr>
            <vue-goodshare-pinterest has_icon :page_url="thisPage"></vue-goodshare-pinterest>
            <vue-goodshare-whats-app has_icon :page_url="thisPage"></vue-goodshare-whats-app>
            <vue-goodshare-viber has_icon :page_url="thisPage"></vue-goodshare-viber>
          </div>
        </div>
      </div>
    </section>

    <!-- LIGHTBOX -->
    <div class="modal is-active" v-if="lightbox">
      <div class="modal-background" @click="lightbox=!lightbox"></div>
      <div class="modal-content">
        <p class="image">
          <img :src="assetsBaseUrl + lightboxImg">
        </p>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="lightbox=!lightbox"></button>
    </div>
  </div>
  <div v-else>laden
  </div>
</template>

<script>
import Project from '@/components/views/Project'
import Topic from '@/components/views/Topic'
import Content from '@/components/views/Content'
import Sections from '@/components/views/Sections'
import Team from '@/components/views/Team'
import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook.vue'
import VueGoodshareTwitter from 'vue-goodshare/src/providers/Twitter.vue'
import VueGoodsharePinterest from 'vue-goodshare/src/providers/Pinterest.vue'
import VueGoodshareTumblr from 'vue-goodshare/src/providers/Tumblr.vue'
import VueGoodshareLinkedin from 'vue-goodshare/src/providers/LinkedIn.vue'
import VueGoodshareWhatsApp from 'vue-goodshare/src/providers/WhatsApp.vue'
import VueGoodshareViber from 'vue-goodshare/src/providers/Viber.vue'

export default {
  metaInfo () {
    if (!this.article) return {}
    return {
      title: this.article.content.seo.title,
      meta: [
        { vmid: 'description', name: 'description', content: this.article.content.seo.description },
        { vmid: 'twitter:card', name: 'twitter:card', value: 'summary' },
        { vmid: 'og:title', property: 'og:title', content: this.article.content.seo.title },
        { vmid: 'og:type', property: 'og:type', content: this.article.content.seo.ogType },
        { vmid: 'og:url', property: 'og:url', content: window.location.href },
        { vmid: 'og:image', property: 'og:image', content: this.assetsBaseUrl + this.article.content.seo.image.path },
        { vmid: 'og:description', property: 'og:description', content: this.article.content.seo.description }
      ],
      link: this.article.content.seo.can.length ? [
        { rel: 'canonical', href: this.article.content.seo.can }
      ] : [
        { rel: 'canonical', href: window.location.href }
      ]
    }
  },
  props: ['niceUrl'],
  data () {
    return {
      lightbox: false,
      lightboxImg: '',
      thisPage: window.location.href,
      swiperOption: {
        allowTouchMove: false,
        slideToClickedSlide: false,
        loop: true,
        clickable: false,
        autoplay: {
          delay: 10000
        },
        // loop: true,
        // effect: 'fade',
        slidesPerView: 1,
        spaceBetween: 30,
        // loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  methods: {
    showLightbox (v) {
      this.lightbox = true
      this.lightboxImg = v
    }
  },
  components: {
    VueGoodshareFacebook,
    VueGoodshareTwitter,
    VueGoodshareLinkedin,
    VueGoodshareTumblr,
    VueGoodsharePinterest,
    VueGoodshareViber,
    VueGoodshareWhatsApp,
    appProject: Project,
    appTopic: Topic,
    appContent: Content,
    appSections: Sections,
    appTeam: Team
  },
  computed: {
    isReady () {
      return this.$store.getters.isReady
    },
    article () {
      if (this.$store.getters.getPage(this.niceUrl)) {
        return this.$store.getters.getPage(this.niceUrl)
      } else {
        this.$store.commit('changeLangContent')
        return this.$store.getters.getPage(this.niceUrl)
      }
    },
    assetsBaseUrl () {
      return this.$store.getters.assetsBaseUrl
    },
    pageSliderItems () {
      if (this.article.content.hasOwnProperty('pageSlider') && this.article.content.pageSlider.length) {
        return this.$store.getters.content.filter(el => this.article.content.pageSlider.indexOf(el.id) !== -1)
      }
    }
  }
}
</script>

<style>
  .box {
    margin-top:30px;
  }
  .uc {
    text-transform: uppercase;
  }
/*  .hero-size {
    padding-bottom: 14rem;
    padding-top: 14rem;
    background-color: red;
    overflow: hidden;
  }
@media all and (max-width: 400px) {
.hero-size {
    padding-bottom: 2rem;
    padding-top: 2rem;
}
}*/
</style>



// WEBPACK FOOTER //
// src/components/Views.vue